import React from "react";
import { Link } from "react-router-dom";

// The one button. `to` renders a router <Link>, `href` an <a>, otherwise a
// <button>. Styling: .yc-btn in styles/ui.css. See
// FRONTEND/DESIGN-SYSTEM.md.
//
//   <Button to="/">My Learning</Button>
//   <Button href={`${FRONT}/courses`}>Browse classes</Button>
//   <Button type="submit" block>Log In</Button>
//   <Button variant="secondary|danger|link" size="sm">…</Button>
export default function Button({
  to,
  href,
  size = "md",
  variant = "primary",
  block = false,
  className = "",
  children,
  ...rest
}) {
  const cls = [
    "yc-btn",
    size !== "md" && `yc-btn--${size}`,
    variant !== "primary" && `yc-btn--${variant}`,
    block && "yc-btn--block",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (to)
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );

  if (href)
    return (
      <a href={href} className={cls} {...rest}>
        {children}
      </a>
    );

  return (
    <button type="button" className={cls} {...rest}>
      {children}
    </button>
  );
}
